import {Construtor} from './construtor';
import {PontoFisico} from './ponto-fisico';

export class DadoTransacional implements Construtor<DadoTransacional> {

  public idDadoTransacional: number;
  public nomeDadoTransacional: string;
  public idCliente: number;
  public pontoFisico: PontoFisico;
  public dataInicio: Date;
  public dataFim: Date;
  public valor: number;

  constructor(object?: any) {
    this.pontoFisico = new PontoFisico();
    if (object !== undefined) {
      if (object instanceof DadoTransacional) {
        this.copyObject(object);
      } else if (object instanceof PontoFisico) {
        this.pontoFisico = new PontoFisico(object);
      } else {
        this.parseFromJson(object);
      }
      if (!this.modeloCompleto()) {
        return null;
      }
    }
    return this;
  }

  parseFromJson(dadoTransacional: any): void {
    this.idDadoTransacional = dadoTransacional.idDadoTransacional;
    this.nomeDadoTransacional = dadoTransacional.nomeDadoTransacional;
    this.idCliente = dadoTransacional.idCliente;
    this.pontoFisico = dadoTransacional.pontoFisico;
    this.dataInicio = new Date(dadoTransacional.dataInicio);
    this.dataFim = new Date(dadoTransacional.dataFim);
    this.valor = dadoTransacional.valor;
  }

  copyObject(dadoTransacional: DadoTransacional): void {
    this.idDadoTransacional = dadoTransacional.idDadoTransacional;
    this.nomeDadoTransacional = dadoTransacional.nomeDadoTransacional;
    this.idCliente = dadoTransacional.idCliente;
    this.pontoFisico = dadoTransacional.pontoFisico;
    this.dataInicio = new Date(dadoTransacional.dataInicio);
    this.dataFim = new Date(dadoTransacional.dataFim);
    this.valor = dadoTransacional.valor;
  }
  modeloCompleto(): boolean {
    return this.nomeDadoTransacional !== undefined && this.idCliente !== undefined &&
      this.pontoFisico !== undefined && this.dataInicio !== undefined &&
      this.dataFim !== undefined && this.valor !== undefined;
  }
  getNewInstance(object?: any): DadoTransacional {
    return new DadoTransacional(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/dado-transacional.ts